<script lang="ts" setup>import { computed as _computed } from 'vue';

import { useI18n } from 'vue-i18n';
import type { InstallationSetup } from '~/models';

const { t } = useI18n()

interface Props {
  installationSetup: InstallationSetup;
}

const props = defineProps<Props>()

const annotations: { title: string, show: boolean; }[] = _computed(() => ([
  {
    title: 'noLambda',
    show: props.installationSetup.isPrediction && !!props.installationSetup.category,
  },
  // TODO: implement u threshold concept entirely, deactivated for now
  // {
  //   title: 'optimization',
  //   show: props.installationSetup.category === 'A'
  // },
  {
    title: 'cv',
    show: true,
  },
  {
    title: 'disclaimer',
    show: true,
  }
]))
</script>

<template>
  <div class="footer-container container">
    <ul class="annotations">
      <template v-for="annotation, i in annotations">
        <li
          v-if="annotation.show"
          :key="i"
          class="annotation"
        >{{ t(`printView.preview.annotations.${annotation.title}`) }}</li>
      </template>
    </ul>
  </div>
</template>

<style lang="scss">
  .footer-container {
    margin-top: var(--gutter-xl);
    border-top: 1px solid var(--color-grey-25);
    font-size: 0.8rem;
    align-self: end;

    ul {
      padding-inline-start: var(--gutter-xl);

      .annotation {
        margin: 0.4rem 0;
      }
    }
  }
</style>
